( function ( _s ) {
	_s( window ).on( 'fr:update-url-params', e => {
		const urlParams = e.detail.urlParams;
		//origin + pathname, NOT href.split('?') — that kept any #hash, which would land
		//AFTER the query string ("…/news/#cat=x?order_by=latest") and break both.
		const currPath = window.location.origin + window.location.pathname;
		const newUrl = currPath + ( urlParams.length ? `?${ urlParams }` : '' );
		//The hash is deliberately dropped: the listing engine reads `#cat=…` deep links
		//once on load (util/filter-params.js) and then mirrors the live filter state into
		//the query string. Keeping a stale hash around would resurrect a filter the user
		//had just cleared on the next reload, since the hash is only ever read, never
		//rewritten.
		window.history.replaceState( {}, '', newUrl );
	} );
} )( window._s );
